/** Service Desk console: RMA replacement, historical ticket import and the product funnel (SD-S4-06, SD-S4-07, SD-X-ANL-01). */
export const serviceRmaReplacement = {
  title: "When an RMA ends as replaced",
  intro: "Choose what is recorded when a client's RMA is marked replaced. It applies from the next replacement; earlier ones keep what they got.",
  mode: {
    record: { label: "Record only (default)", hint: "Note on the RMA and its ticket that the client got a replacement from stock. No order is made." },
    order: { label: "Make a zero-value order", hint: "Also place an order for 0.00 in the client's name, so the replacement shows in their order history." },
  },
  neverSent: "Neither is ever sent to the client's own system. If your team keys the order in there, it does that by hand.",
  save: "Save",
  saved: "Replacement setting saved",
  readOnly: "You can read this setting. Changing it needs the right to manage assets.",
  record: {
    title: "Replacement",
    order: "Zero-value order",
    stock: "Replaced from stock",
    openOrder: "Order {{number}}",
    orderHint: "Placed in the client's name for 0.00. It was not sent to the client's system.",
    product: "Product",
    sku: "SKU",
    serial: "Serial number",
    quantity: "Quantity",
    recorded: "Recorded",
    error: "The replacement couldn't load.",
  },
  fallback: {
    no_profile: "The workspace has no commerce profile, so the replacement was recorded instead of an order.",
    no_organisation: "The RMA has no organisation, so the replacement was recorded instead of an order.",
    no_contact: "The organisation has no contact who may order, so the replacement was recorded instead of an order.",
  },
} as const;

export const serviceImportHistory = {
  points: {
    quiet: "Nobody is told. No e-mail, no push and no bell item go to clients or staff, and the tickets are not announced anywhere.",
    sla: "No SLA clock starts. Imported tickets keep their old dates and never breach or escalate. A row can ask for timers with the sla_timers column; they run only if the ticket is still open.",
    idempotent: "Run it again safely. Each row's external_id is the id it had in the old system: a row that is already in is skipped and an imported ticket is never rewritten.",
    dates: "Old dates stay. Created, updated, resolved and closed times are kept as given (UTC unless the date carries an offset).",
  },
  upload: {
    title: "Importing history, not new work",
    formats: "A CSV, or JSON lines (.jsonl): one ticket per line, with its messages inside. Use Validate first: the dry run lists every row error and writes nothing.",
    dropTitle: "Drop a CSV or JSON lines file here",
    dropHint: "UTF-8, up to {{size}} MB and {{rows}} tickets. A CSV's first row holds the column names.",
    choose: "Choose a file",
  },
  validate: { title: "Dry run: nothing is saved, nobody is told" },
  done: { title: "Imported quietly", openTickets: "Open tickets" },
} as const;

export const serviceProductFunnel = {
  label: "Product funnel figures",
  weekOf: "Week of {{date}}",
  kpi: {
    intake: "Intake completion",
    intakeSub: "{{submitted}} submitted of {{started}} started",
    portal: "Portal sign-ins",
    portalSub: "clients who opened the portal",
    conversion: "Cart to order",
    conversionSub: "{{orders}} orders from {{carts}} carts",
    quotes: "Quote acceptance",
    quotesSub: "{{accepted}} accepted of {{requested}} requested",
  },
  step: {
    intake_started: "Intake started",
    intake_submitted: "Intake submitted (ticket opened)",
    deflected: "“That solved it”",
    portal_opened: "Portal sign-in",
    cart_started: "Cart started",
    order_placed: "Order placed",
    quote_requested: "Quote requested",
    quote_accepted: "Quote accepted",
    visit_window_chosen: "Visit window chosen",
    acceptance_done: "Installation accepted",
  },
  steps: {
    title: "Product funnel",
    sub: "Steps clients took, {{period}}",
    column: "Step",
    count: "Times",
    rate: "Rate",
  },
  weeks: {
    title: "Funnel by week",
    sub: "Intake and orders week by week, {{period}}",
    column: "Week",
    conversion: "Cart to order",
  },
} as const;
